import * as Sentry from '@sentry/nextjs';
import Stripe from 'stripe';
import api from 'services/client/api';
import { detectFraudFromBrowser } from 'utils/shared/fraud/detectFraud';

export interface Response {
  publishableKey: string | undefined;
  ephemeralKey: string | undefined;
  setupIntentClientSecret: string | undefined;
  customerId: string | null;
}

export const SETUP_INTENT_API = 'v1/payment-providers/stripe/setup-intent';

export const getSetupIntent = async () => {
  // Check for fraud before making the request
  const fraudDetection = detectFraudFromBrowser();
  if (fraudDetection.isFraud) {
    Sentry.captureException(new Error('Fraud attempt detected during setup intent'), {
      extra: {
        reason: fraudDetection.reason,
        timezone: fraudDetection.timezone,
        locale: fraudDetection.locale,
      },
    });
    throw new Error('Unable to process payment. Please try again later.');
  }

  const response = await api.post(SETUP_INTENT_API, {
    payload: {
      timezone: fraudDetection.timezone,
      locale: fraudDetection.locale,
    },
  });
  return response as Response;
};
